import { Route, Switch } from 'react-router-dom';

import { ROUTES } from '../../constants/routes';
import { Company, EditCompany, CreateCompany } from './index';

export const CompanyRouts = () => (
  <Switch>
    <Route path={ROUTES.COMPANY} component={Company} />
    <Route path={ROUTES.EDIT_COMPANY} component={EditCompany} />
    <Route path={ROUTES.CREATE_COMPANY} component={CreateCompany} />
  </Switch>
);
